// extracted by mini-css-extract-plugin
export default {"container":"SS-z","title":"TS-z","link":"US-z"};